import api from './base';
import { GetListType } from './types/GetListType';

class CategoryAssignmentsApi {
  public getCategoryAssignments = async (params?: any) => {
    const response = await api.get(`/cfgCHType-assignments`, {
      params: { ...params },
    });

    return response.data;
  };
}

export default new CategoryAssignmentsApi();
